/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from './components/modal.ngfactory';
import * as i2 from '../../app/components/modal';
import * as i3 from '../../app/services/modal';
import * as i4 from '@angular/router';
import * as i5 from '../../app/app.component';
import * as i6 from 'angular2-token';
const styles_AppComponent:any[] = ([] as any[]);
export const RenderType_AppComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵeld(1,
      0,(null as any),(null as any),1,'modal',([] as any[]),(null as any),(null as any),
      (null as any),i1.View_ModalComponent_0,i1.RenderType_ModalComponent)),i0.ɵdid(2,
      114688,(null as any),0,i2.ModalComponent,[i3.ModalService,i0.ComponentFactoryResolver],
      (null as any),(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),
      i0.ɵeld(4,16777216,(null as any),(null as any),1,'router-outlet',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(5,212992,(null as any),0,i4.RouterOutlet,[i4.ChildrenOutletContexts,
          i0.ViewContainerRef,i0.ComponentFactoryResolver,[8,(null as any)],i0.ChangeDetectorRef],
          (null as any),(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n  ']))],
      (_ck,_v) => {
        _ck(_v,2,0);
        _ck(_v,5,0);
      },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'my-app',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i0.ɵdid(1,49152,(null as any),0,i5.AppComponent,[i6.Angular2TokenService],(null as any),
          (null as any))],(null as any),(null as any));
}
export const AppComponentNgFactory:i0.ComponentFactory<i5.AppComponent> = i0.ɵccf('my-app',
    i5.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvYXBwLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPG1vZGFsPjwvbW9kYWw+XG4gICAgPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PlxuICAiLCI8bXktYXBwPjwvbXktYXBwPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUEsOENBQ0k7TUFBQTtNQUFBLDZFQUFBO01BQUE7TUFBQSw2QkFBZSw4Q0FDZjthQUFBO1VBQUE7YUFBQTswREFBQTtVQUFBLDZCQUErQjs7UUFEL0I7UUFDQTs7OztvQkNGSjtNQUFBO2FBQUE7VUFBQTs7OyJ9



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/$$_gendir/app/app.component.ngfactory.ts